import { Link } from "react-router";
import { useLocale, useTranslations } from "use-intl";
import { Plus } from "lucide-react";
import { lt } from "@liftquest/shared/localized";
import { Page, PageHeader } from "@/components/app/page-header";
import { PageLoading } from "@/components/app/states";
import { Button } from "@/components/ui/button";
import { useExercises } from "@/lib/queries";
import { ExerciseList } from "./exercise-list";

export function ExercisesPage() {
  const locale = useLocale();
  const t = useTranslations("exercises");
  const { data } = useExercises();
  const items = (data ?? [])
    .map((e) => ({
      id: e.id,
      name: lt(e.name, locale),
      type: e.type,
      muscles: e.muscles,
      equipment: e.equipment,
      custom: !e.slug,
      hasVideo: !!e.videoUrl,
    }))
    .sort((a, b) => a.name.localeCompare(b.name, locale));
  return (
    <Page>
      <PageHeader
        title={t("title")}
        actions={
          <Button asChild size="lg" className="rounded-full">
            <Link to="/exercises/new">
              <Plus /> {t("new")}
            </Link>
          </Button>
        }
      />
      {data ? <ExerciseList items={items} /> : <PageLoading />}
    </Page>
  );
}
